import { render, staticRenderFns } from "./nearby-shop-group.vue?vue&type=template&id=165c2b28&scoped=true&"
import script from "./nearby-shop-group.vue?vue&type=script&lang=js&"
export * from "./nearby-shop-group.vue?vue&type=script&lang=js&"
import style0 from "./nearby-shop-group.vue?vue&type=style&index=0&id=165c2b28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165c2b28",
  null
  
)

export default component.exports